export default {"src":"/_next/static/media/google_pay.15f85da0.svg","height":16,"width":40,"blurWidth":0,"blurHeight":0};